import React, { useMemo, useState } from "react";
import { Leaf, ChevronRight, ChevronLeft, RotateCcw, Check } from "lucide-react";

// ---------- Kuratierte Beispiel-ETF-Liste (fiktiv, nur zur Demonstration der Logik) ----------

const ETFS = [
  // --- iShares "SRI" Linie (MSCI ... SRI Select Reduced Fossil Fuels Index) ---
  // Dokumentierte Ausschlüsse (iShares-Factsheet): kontroverse Waffen, Atomwaffen, Tabak, Schusswaffen,
  // konventionelle Waffen, Alkohol, Glücksspiel, Erwachsenenunterhaltung, Atomkraft, GVO + UN-Global-Compact-Prüfung
  { name: "iShares MSCI World SRI UCITS ETF EUR (Acc)", isin: "IE00BYX2JD69", ter: 0.20, region: "Global", risk: "Ausgewogen", distribution: "Thesaurierend", fundSize: 7155, inception: "12.10.17", replication: "Voll", exclusions: ["Rüstung", "Fossile Energien", "Atomkraft", "Tabak", "Glücksspiel", "Kinderarbeit / Menschenrechte"], note: "Größter und günstigster ETF auf den MSCI World SRI Reduced Fossil Fuel Index, inkl. UN-Global-Compact-Prüfung." },
  { name: "iShares MSCI World SRI UCITS ETF USD (Dist)", isin: "IE00BDZZTM54", ter: 0.20, region: "Global", risk: "Ausgewogen", distribution: "Ausschüttend", fundSize: 1610, inception: "12.10.17", replication: "Voll", exclusions: ["Rüstung", "Fossile Energien", "Atomkraft", "Tabak", "Glücksspiel", "Kinderarbeit / Menschenrechte"], note: "Ausschüttende Variante (vierteljährlich) desselben Index wie oben." },
  { name: "iShares MSCI Europe SRI UCITS ETF (Acc)", isin: "IE00B52VJ196", ter: 0.20, region: "Europa", risk: "Ausgewogen", distribution: "Thesaurierend", fundSize: 3294, inception: "25.02.11", replication: "Voll", exclusions: ["Rüstung", "Fossile Energien", "Atomkraft", "Tabak", "Glücksspiel", "Kinderarbeit / Menschenrechte"], note: "Ältester und größter Europa-SRI-ETF im Sample, seit 2011 am Markt." },
  { name: "iShares MSCI Europe SRI UCITS ETF USD (Acc)", isin: "IE00BMDBMG37", ter: 0.20, region: "Europa", risk: "Ausgewogen", distribution: "Thesaurierend", replication: "Voll", exclusions: ["Rüstung", "Fossile Energien", "Atomkraft", "Tabak", "Glücksspiel", "Kinderarbeit / Menschenrechte"], note: "USD-Anteilsklasse desselben Europa-SRI-Index." },
  { name: "iShares MSCI EM SRI UCITS ETF", isin: "IE00BYVJRP78", ter: 0.25, region: "Schwellenländer", risk: "Wachstumsorientiert", distribution: "Thesaurierend", fundSize: 2975, replication: "Voll", exclusions: ["Rüstung", "Fossile Energien", "Atomkraft", "Tabak", "Glücksspiel", "Kinderarbeit / Menschenrechte"], note: "Einziger breiter SRI-ETF auf Schwellenländer-Aktien in diesem Sample." },
  { name: "iShares MSCI USA SRI UCITS ETF USD (Acc)", isin: "IE00BYVJRR92", ter: 0.20, region: "Global", risk: "Ausgewogen", distribution: "Thesaurierend", fundSize: 3450, replication: "Voll", exclusions: ["Rüstung", "Fossile Energien", "Atomkraft", "Tabak", "Glücksspiel", "Kinderarbeit / Menschenrechte"], note: "US-Fokus, gleiche SRI-Methodik wie die Welt-Variante." },
  { name: "iShares MSCI USA SRI UCITS ETF USD (Dist)", isin: "IE00BZ173T46", ter: 0.20, region: "Global", risk: "Ausgewogen", distribution: "Ausschüttend", fundSize: 293, replication: "Voll", exclusions: ["Rüstung", "Fossile Energien", "Atomkraft", "Tabak", "Glücksspiel", "Kinderarbeit / Menschenrechte"], note: "Ausschüttende Variante (halbjährlich), kleineres Fondsvolumen." },
  { name: "iShares MSCI EMU SRI UCITS ETF EUR (Acc)", isin: "IE00BJLKK341", ter: 0.20, region: "Europa", risk: "Sicherheitsorientiert", distribution: "Thesaurierend", fundSize: 37, inception: "03.03.20", replication: "Voll", exclusions: ["Rüstung", "Fossile Energien", "Atomkraft", "Tabak", "Glücksspiel", "Kinderarbeit / Menschenrechte"], note: "Fokus auf Eurozone statt Gesamteuropa, kleineres Nischenprodukt." },
  { name: "iShares MSCI EMU SRI UCITS ETF EUR (Dist)", isin: "IE00BJM0B415", ter: 0.20, region: "Europa", risk: "Sicherheitsorientiert", distribution: "Ausschüttend", fundSize: 5, inception: "03.03.20", replication: "Voll", exclusions: ["Rüstung", "Fossile Energien", "Atomkraft", "Tabak", "Glücksspiel", "Kinderarbeit / Menschenrechte"], note: "Ausschüttende Eurozone-Variante, sehr kleines Fondsvolumen." },

  // --- Amundi "SRI PAB" / "SRI Climate PAB" Linie (Best-in-Class-ESG + EU-Klimabenchmark-Ausschlüsse) ---
  { name: "Amundi Index MSCI World SRI PAB UCITS ETF DR (C)", isin: "LU1861134382", ter: 0.18, region: "Global", risk: "Ausgewogen", distribution: "Thesaurierend", replication: "Voll", exclusions: ["Fossile Energien", "Atomkraft"], note: "Günstigster Welt-ESG-ETF im Sample, Best-in-Class-Ansatz mit EU-Klimabenchmark-Ausschlüssen (weniger strikte Sektorausschlüsse als die SRI-Linie)." },
  { name: "Amundi MSCI World SRI Climate Paris Aligned UCITS ETF Acc", isin: "IE000Y77LGG9", ter: 0.18, region: "Global", risk: "Ausgewogen", distribution: "Thesaurierend", replication: "Voll", exclusions: ["Fossile Energien", "Atomkraft"], note: "Paris-Aligned-Klassifizierung, gleiche Indexmethodik wie oben." },
  { name: "Amundi MSCI World SRI Climate Paris Aligned UCITS ETF Dist", isin: "IE000004V778", ter: 0.18, region: "Global", risk: "Ausgewogen", distribution: "Ausschüttend", fundSize: 54, replication: "Voll", exclusions: ["Fossile Energien", "Atomkraft"], note: "Ausschüttende Variante (jährlich), kleineres Fondsvolumen." },
  { name: "Amundi Index MSCI World SRI PAB UCITS ETF DR Hedged EUR (C)", isin: "LU2249056297", ter: 0.20, region: "Global", risk: "Sicherheitsorientiert", distribution: "Thesaurierend", fundSize: 460, replication: "Voll", exclusions: ["Fossile Energien", "Atomkraft"], note: "Währungsgesichert in Euro, reduziert Wechselkursrisiko gegenüber USD-Positionen." },
  { name: "Amundi MSCI World SRI Climate PAB Acc EUR Hedged", isin: "IE000K1P4V37", ter: 0.20, region: "Global", risk: "Sicherheitsorientiert", distribution: "Thesaurierend", replication: "Voll", exclusions: ["Fossile Energien", "Atomkraft"], note: "Währungsgesicherte Variante der Climate-PAB-Linie." },
  { name: "Amundi Index MSCI USA SRI PAB UCITS ETF DR (C)", isin: "LU1861136247", ter: 0.18, region: "Global", risk: "Ausgewogen", distribution: "Thesaurierend", fundSize: 4666, replication: "Voll", exclusions: ["Fossile Energien", "Atomkraft"], note: "US-Fokus, mit 4,7 Mrd. € eines der größten Produkte in diesem Sample." },
  { name: "Amundi MSCI ACWI SRI Climate Paris Aligned UCITS ETF DR (USD)", isin: "IE0000ZVYDH0", ter: 0.20, region: "Schwellenländer", risk: "Wachstumsorientiert", distribution: "Thesaurierend", replication: "Voll", exclusions: ["Fossile Energien", "Atomkraft"], note: "Einziger ETF im Sample, der Industrie- und Schwellenländer gemeinsam abdeckt (ACWI)." },

  // --- Xtrackers "ESG" Linie (MSCI ... Low Carbon SRI Selection, Best-in-Class + CO2-Reduktion) ---
  { name: "Xtrackers MSCI World ESG UCITS ETF 1C", isin: "IE00BZ02LR44", ter: 0.20, region: "Global", risk: "Ausgewogen", distribution: "Thesaurierend", fundSize: 6330, inception: "24.04.18", replication: "Voll", exclusions: ["Fossile Energien"], note: "Best-in-Class-ESG mit CO2-Reduktionsziel, breiter aufgestellt (mehr Positionen) als die reine SRI-Linie." },
  { name: "Xtrackers MSCI World ESG UCITS ETF 2C EUR Hedged", isin: "IE00BMY76136", ter: 0.25, region: "Global", risk: "Sicherheitsorientiert", distribution: "Thesaurierend", fundSize: 1070, replication: "Voll", exclusions: ["Fossile Energien"], note: "Währungsgesicherte Variante, etwas höhere TER durch das Hedging." },
  { name: "Xtrackers MSCI World Momentum ESG UCITS ETF", isin: "IE000TL3PL69", ter: 0.25, region: "Global", risk: "Wachstumsorientiert", distribution: "Thesaurierend", fundSize: 230, replication: "Voll", exclusions: ["Fossile Energien"], note: "Kombiniert ESG-Filter mit Momentum-Faktor, höheres Renditepotenzial bei höherer Schwankung." },
  { name: "Xtrackers MSCI World Value ESG UCITS ETF 1C", isin: "IE000LAUZQT6", ter: 0.25, region: "Global", risk: "Sicherheitsorientiert", distribution: "Thesaurierend", fundSize: 277, replication: "Voll", exclusions: ["Fossile Energien"], note: "Kombiniert ESG-Filter mit Value-Faktor, defensiverer Charakter." },

  // --- Weitere Anbieter ("Screened"-Indizes) ---
  { name: "HSBC Developed World Screened Equity UCITS ETF", isin: "IE00BKY59K37", ter: 0.18, region: "Global", risk: "Ausgewogen", distribution: "Thesaurierend", replication: "Sampling", exclusions: ["Rüstung", "Fossile Energien", "Tabak"], note: "Werteorientierter Ausschlussfilter (Screened-Index), günstiger als die meisten SRI-Produkte." },
  { name: "Xtrackers MSCI AC World Screened UCITS ETF 1C", isin: "IE00BGHQ0G80", ter: 0.20, region: "Schwellenländer", risk: "Wachstumsorientiert", distribution: "Thesaurierend", fundSize: 5957, replication: "Sampling", exclusions: ["Rüstung", "Fossile Energien", "Tabak"], note: "Deckt Industrie- und Schwellenländer gemeinsam ab (All Country World), 5,9 Mrd. € Fondsvolumen." },

  // --- VanEck Themen-ETFs (SFDR Art. 9 laut VanEck, MVIS ESG-Indizes, sektorkonzentriert) ---
  { name: "VanEck Sustainable Future of Food UCITS ETF", isin: "IE0005B8WVT6", ter: 0.45, region: "Global", risk: "Wachstumsorientiert", distribution: "Thesaurierend", fundSize: 13, inception: "24.06.22", replication: "Voll", exclusions: ["Fossile Energien"], note: "Themen-ETF auf nachhaltige Lebensmittelproduktion (Alternativproteine, vertikale Landwirtschaft); konzentriertes Portfolio, höheres Einzeltitelrisiko." },
  { name: "VanEck Circular Economy UCITS ETF", isin: "IE0001J5A2T9", ter: 0.40, region: "Global", risk: "Wachstumsorientiert", distribution: "Thesaurierend", fundSize: 15, inception: "21.10.22", replication: "Voll", exclusions: ["Fossile Energien"], note: "Themen-ETF auf Kreislaufwirtschaft (Recycling, Wasseraufbereitung, Abfallmanagement), Einzeltitel-Cap bei 8 %." },
  { name: "VanEck Hydrogen Economy UCITS ETF", isin: "IE00BMDH1538", ter: 0.55, region: "Global", risk: "Wachstumsorientiert", distribution: "Thesaurierend", fundSize: 118, replication: "Voll", exclusions: ["Fossile Energien"], note: "Themen-ETF auf die Wasserstoff-Wertschöpfungskette; höchste TER im Sample, entsprechend spekulativer Wachstumssektor." },
];

const STEPS = [
  {
    key: "exclusions",
    question: "Welche Branchen sollen in Ihrem ETF ausgeschlossen sein?",
    hint: "Mehrfachauswahl möglich",
    type: "multi",
    options: ["Rüstung", "Fossile Energien", "Atomkraft", "Tabak", "Glücksspiel", "Kinderarbeit / Menschenrechte"],
  },
  {
    key: "risk",
    question: "Wie würden Sie Ihre Risikoneigung einschätzen?",
    type: "single",
    options: [
      { value: "Sicherheitsorientiert", label: "Sicherheitsorientiert", hint: "Stabilität wichtiger als Wachstum" },
      { value: "Ausgewogen", label: "Ausgewogen", hint: "Solide Mischung aus Stabilität und Wachstum" },
      { value: "Wachstumsorientiert", label: "Wachstumsorientiert", hint: "Höhere Schwankungen für mehr Renditepotenzial akzeptabel" },
    ],
  },
  {
    key: "costFocus",
    question: "Was ist Ihnen wichtiger: niedrige Kosten oder strenge Nachhaltigkeitskriterien?",
    type: "single",
    options: [
      { value: "Kosten", label: "Möglichst niedrige Kosten (TER)", hint: "Nachhaltigkeit ja, aber Kosten stehen im Vordergrund" },
      { value: "Balance", label: "Ausgewogen", hint: "Beides soll eine Rolle spielen" },
      { value: "Wirkung", label: "Strenge Kriterien wichtiger als Kosten", hint: "Möglichst viele Ausschlüsse, Art. 9 bevorzugt" },
    ],
  },
  {
    key: "region",
    question: "Welchen regionalen Fokus bevorzugen Sie?",
    type: "single",
    options: [
      { value: "Global", label: "Global breit gestreut" },
      { value: "Europa", label: "Europa-Fokus" },
      { value: "Schwellenländer", label: "Mit Schwellenländer-Anteil" },
    ],
  },
  {
    key: "distribution",
    question: "Thesaurierend oder ausschüttend?",
    type: "single",
    options: [
      { value: "Thesaurierend", label: "Thesaurierend", hint: "Erträge werden automatisch reinvestiert" },
      { value: "Ausschüttend", label: "Ausschüttend", hint: "Regelmäßige Auszahlung der Erträge" },
      { value: "Egal", label: "Keine Präferenz" },
    ],
  },
];

const FOREST = "#3E5743";
const FOREST_DARK = "#2C3F32";
const CREAM = "#F7F5EF";

function scoreETF(etf, answers) {
  let score = 0;
  const reasons = [];

  const excl = answers.exclusions || [];
  const metExclusions = excl.filter((e) => etf.exclusions.includes(e));
  score += metExclusions.length * 3;
  if (excl.length > 0) {
    reasons.push(`Schließt ${metExclusions.length} von ${excl.length} gewünschten Branchen aus`);
  }

  if (answers.risk && etf.risk === answers.risk) {
    score += 4;
    reasons.push(`Risikoprofil passt: ${etf.risk}`);
  }

  if (answers.costFocus === "Kosten") {
    score += Math.max(0, 6 - etf.ter * 15);
    if (etf.ter <= 0.20) reasons.push(`Günstige TER von ${etf.ter.toFixed(2)} %`);
  } else if (answers.costFocus === "Wirkung") {
    score += etf.exclusions.length * 0.8;
    if (etf.exclusions.length >= 5) reasons.push("Besonders umfassender Ausschlusskatalog");
  } else {
    score += Math.max(0, 3 - etf.ter * 8);
  }

  if (answers.region && etf.region === answers.region) {
    score += 3;
    reasons.push(`Regionaler Fokus: ${etf.region}`);
  }

  if (answers.distribution && answers.distribution !== "Egal" && etf.distribution === answers.distribution) {
    score += 2;
    reasons.push(`Ausschüttungsart wie gewünscht: ${etf.distribution}`);
  }

  return { score, reasons };
}

export default function ESGFitQuiz() {
  const [step, setStep] = useState(0);
  const [answers, setAnswers] = useState({ exclusions: [] });
  const [showResult, setShowResult] = useState(false);

  const current = STEPS[step];
  const progress = ((step + (showResult ? 1 : 0)) / STEPS.length) * 100;

  function toggleMulti(value) {
    setAnswers((a) => {
      const arr = a.exclusions || [];
      return {
        ...a,
        exclusions: arr.includes(value) ? arr.filter((v) => v !== value) : [...arr, value],
      };
    });
  }

  function selectSingle(key, value) {
    setAnswers((a) => ({ ...a, [key]: value }));
  }

  function canProceed() {
    if (current.type === "multi") return true;
    return !!answers[current.key];
  }

  function next() {
    if (step < STEPS.length - 1) {
      setStep(step + 1);
    } else {
      setShowResult(true);
    }
  }

  function back() {
    if (showResult) {
      setShowResult(false);
    } else if (step > 0) {
      setStep(step - 1);
    }
  }

  function restart() {
    setStep(0);
    setAnswers({ exclusions: [] });
    setShowResult(false);
  }

  const ranked = useMemo(() => {
    if (!showResult) return [];
    return ETFS.map((e) => ({ ...e, ...scoreETF(e, answers) }))
      .sort((a, b) => b.score - a.score)
      .slice(0, 3);
  }, [showResult, answers]);

  return (
    <div className="w-full">
      <div className="max-w-4xl mx-auto px-2 sm:px-5 py-2 sm:py-4">
        <div
          className="rounded-lg p-2 mb-5 text-xs leading-relaxed"
          style={{ background: "#EFEBDD", color: "#6B6350", border: "1px solid #E1DAC4" }}
        >
          Unsere Auswahl umfasst 25 recherchierte SRI- und ESG-Aktien-ETFs (ISIN, TER, Fondsgröße und Auflegedatum
          jeweils geprüft; die drei VanEck-Themen-ETFs sind laut Anbieter als SFDR Artikel 9 eingestuft). Die
          Zuordnung der Ausschlusskriterien orientiert sich an der öffentlich dokumentierten Indexmethodik der
          jeweiligen Produktlinie. Das Quiz ersetzt keine individuelle Anlageberatung.
        </div>

        <div
          className="bg-white rounded-xl p-0"
          style={{ fontFamily: "'IBM Plex Sans', system-ui, Arial, sans-serif" }}
        >
          {/* Fortschrittsbalken */}
          <div className="flex items-center gap-1 mb-6">
            {STEPS.map((s, i) => (
              <div
                key={s.key}
                className="flex-1 h-1 rounded-full"
                style={{ background: i < step || showResult ? FOREST : i === step ? "#B7C2B4" : "#E4E0D2" }}
              />
            ))}
          </div>

          {!showResult ? (
            <div>
              <h2 className="text-base font-medium mb-1" style={{ color: FOREST_DARK }}>
                {current.question}
              </h2>
              {current.hint && (
                <p className="text-xs mb-4" style={{ color: "#8A8570" }}>{current.hint}</p>
              )}
              {!current.hint && <div className="mb-4" />}

              {current.type === "multi" && (
                <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
                  {current.options.map((opt) => {
                    const active = (answers.exclusions || []).includes(opt);
                    return (
                      <button
                        key={opt}
                        onClick={() => toggleMulti(opt)}
                        className="text-left px-3 py-2.5 rounded-lg text-xs flex items-center gap-2 transition"
                        style={
                          active
                            ? { background: FOREST, color: "#fff", border: `1px solid ${FOREST}` }
                            : { background: "#FBFAF5", color: "#5B6B5E", border: "1px solid #D8D3C2" }
                        }
                      >
                        <span
                          className="w-4 h-4 rounded flex items-center justify-center shrink-0"
                          style={{ background: active ? "#fff" : "transparent", border: active ? "none" : "1px solid #B7C2B4" }}
                        >
                          {active && <Check className="w-3 h-3" style={{ color: FOREST }} />}
                        </span>
                        {opt}
                      </button>
                    );
                  })}
                </div>
              )}

              {current.type === "single" && (
                <div className="flex flex-col gap-2">
                  {current.options.map((opt) => {
                    const active = answers[current.key] === opt.value;
                    return (
                      <button
                        key={opt.value}
                        onClick={() => selectSingle(current.key, opt.value)}
                        className="text-left px-3 py-2.5 rounded-lg text-xs transition"
                        style={
                          active
                            ? { background: FOREST, color: "#fff", border: `1px solid ${FOREST}` }
                            : { background: "#FBFAF5", color: "#5B6B5E", border: "1px solid #D8D3C2" }
                        }
                      >
                        <div className="font-medium">{opt.label}</div>
                        {opt.hint && (
                          <div className="text-[11px] mt-0.5" style={{ color: active ? "#E4E9E1" : "#A8A390" }}>
                            {opt.hint}
                          </div>
                        )}
                      </button>
                    );
                  })}
                </div>
              )}

              <div className="flex justify-between mt-6">
                <button
                  onClick={back}
                  disabled={step === 0}
                  className="flex items-center gap-1 text-xs px-3 py-1.5 rounded"
                  style={{ color: step === 0 ? "#C7C2B0" : "#5B6B5E", border: "1px solid #D8D3C2", opacity: step === 0 ? 0.5 : 1 }}
                >
                  <ChevronLeft className="w-3.5 h-3.5" /> Zurück
                </button>
                <button
                  onClick={next}
                  disabled={!canProceed()}
                  className="flex items-center gap-1 text-xs px-4 py-1.5 rounded font-medium"
                  style={{
                    background: canProceed() ? FOREST : "#D8D3C2",
                    color: "#fff",
                    cursor: canProceed() ? "pointer" : "not-allowed",
                  }}
                >
                  {step === STEPS.length - 1 ? "Ergebnis anzeigen" : "Weiter"} <ChevronRight className="w-3.5 h-3.5" />
                </button>
              </div>
            </div>
          ) : (
            <div>
              <h2 className="text-base font-medium mb-4" style={{ color: FOREST_DARK }}>
                Ihre persönliche ETF-Empfehlung
              </h2>

              {ranked.map((etf, i) => (
                <div
                  key={etf.isin}
                  className="rounded-lg p-4 mb-3"
                  style={
                    i === 0
                      ? { background: "#F2F6F1", border: `1.5px solid ${FOREST}` }
                      : { background: "#FBFAF5", border: "1px solid #EDE9DB" }
                  }
                >
                  <div className="flex items-center justify-between mb-1">
                    <div className="flex items-center gap-2">
                      {i === 0 && (
                        <span
                          className="text-[10px] font-medium px-2 py-0.5 rounded-full"
                          style={{ background: FOREST, color: "#fff" }}
                        >
                          Beste Übereinstimmung
                        </span>
                      )}
                      <span className="text-sm font-medium" style={{ color: FOREST_DARK }}>{etf.name}</span>
                    </div>
                    <span className="text-xs" style={{ color: "#8A8570" }}>{etf.isin}</span>
                  </div>
                  <p className="text-xs mb-2" style={{ color: "#6B6350" }}>{etf.note}</p>
                  <div className="flex flex-wrap gap-2 mb-2">
                    {[
                      `TER ${etf.ter.toFixed(2)} %`,
                      etf.region,
                      etf.distribution,
                      etf.fundSize ? `${etf.fundSize.toLocaleString("de-DE")} Mio €` : null,
                    ].filter(Boolean).map((tag) => (
                      <span
                        key={tag}
                        className="text-[10px] px-2 py-0.5 rounded-full"
                        style={{ background: "#EDE9DB", color: "#6B6350" }}
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                  {etf.reasons.length > 0 && (
                    <ul className="text-[11px] space-y-0.5" style={{ color: "#5B6B5E" }}>
                      {etf.reasons.map((r, j) => (
                        <li key={j} className="flex items-start gap-1.5">
                          <Check className="w-3 h-3 mt-0.5 shrink-0" style={{ color: FOREST }} />
                          {r}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              ))}

              <p className="text-xs mt-3 mb-4" style={{ color: "#A8A390" }}>
                Empfehlung auf Basis Ihrer Angaben und unserer redaktionell kuratierten ETF-Auswahl. Keine
                Anlageberatung.
              </p>

              <div className="flex justify-between">
                <button
                  onClick={back}
                  className="flex items-center gap-1 text-xs px-3 py-1.5 rounded"
                  style={{ color: "#5B6B5E", border: "1px solid #D8D3C2" }}
                >
                  <ChevronLeft className="w-3.5 h-3.5" /> Zurück
                </button>
                <button
                  onClick={restart}
                  className="flex items-center gap-1.5 text-xs px-4 py-1.5 rounded font-medium"
                  style={{ background: FOREST, color: "#fff" }}
                >
                  <RotateCcw className="w-3.5 h-3.5" /> Neu starten
                </button>
              </div>
            </div>
          )}
        </div>

        </div>
    </div>
  );
}
